import React, { useState } from "react";
import classes from "./analytics.module.css";
import {
  PaymentIconRed,
  UserIconRed,
  StarIconRed,
  WorkingHoursRed,
  ArrowUpRightBlue,
  GraphBlueIcon,
  GraphGrayIcon,
  BarBlueIcon,
  BarGrayIcon,
  ListIconBlue,
  ListIconGray,
  CalendarIconGray,
  CalendarIconBlue,
  SecuredPaymentIcon,
} from "../../../../constant/imagePath";
import { Container, Row, Col } from "react-bootstrap";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { ButtonGroup } from "../../../../stories/ButtonGroup/ButtonGroup";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { ReactSVG } from "react-svg";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";
import moment from "moment";
import StatisticModal from "../../../../components/Modals/CoachFlow/Insights/StatisticModal/StatisticModal";

const Analytics = () => {
  const [graphView, setGraphView] = useState("bar");
  const [statsModal, setStatsModal] = useState(false);

  const summary = [
    {
      title: "Income this week",
      img: PaymentIconRed,
      value: '$500',
    },
    {
      title: "Hours worked",
      img: WorkingHoursRed,
      value: 22,
    },
    {
      title: "No. of sessions",
      img: StarIconRed,
      value: 24,
    },
    {
      title: "No. of students",
      img: UserIconRed,
      value: 5,
    },
  ];

  const labels = [
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
    `${moment().format("ddd")} ${moment().format("MMM DD,YY")}`,
  ];

  const options = {
    scales: {
      y: {
        ticks: {
          callback: function (value) {
            return "$" + value;
          },
          stepSize: 100,
        },
        min: 0,
        max: 400,
        position: "left",
        type: "linear",
      },
      y1: {
        ticks: {
          callback: function (value) {
            return value + "h";
          },
          stepSize: 2,
        },
        min: 0,
        max: 8,
        position: "right",
        type: "linear",
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    categoryPercentage: 0.3,
    barPercentage: 0.5,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Income",
        data: [100, 200, 300, 380, 350, 250, 150],
        backgroundColor: `${Colors.errorColor}`,
        borderColor: `${Colors.errorColor}`,
        borderRadius: 14,
        yAxisID: "y",
      },
      {
        label: "Hours",
        data: [1, 5, 2, 3, 6, 4, 7],
        backgroundColor: `${Colors.mainBlue}`,
        borderColor: `${Colors.mainBlue}`,
        borderRadius: 14,
        yAxisID: "y1",
      },
    ],
  };
  return (
    <div className={[classes.mt32].join(" ")}>
      <Row
        className={["g-0", classes.borderRadius10].join(" ")}
        style={{ border: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
      >
        {summary?.map((item, i) => {
          return (
            <Col md={3}>
              <div
                style={{
                  borderRight:
                    summary.length - 1 !== i &&
                    `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
                className={[classes.AnalyticsMiddleSection].join(" ")}
              >
                <p
                  style={{
                    ...Fonts.otherSemiBold,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                  className={[classes.mb4].join(" ")}
                >
                  {item.title}
                </p>
                <div className={[classes.dflex, classes.itemscenter].join(" ")}>
                  <ReactSVG
                    src={item.img}
                    className={[classes.AnalyticsMiddleSectionImg].join(" ")}
                  />
                  <h4
                    className={[classes.ml16].join(" ")}
                    style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
                  >
                    {item.value}
                  </h4>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
      <div className={[classes.legendsDiv].join(" ")}>
        <div className={[classes.dflex].join(" ")}>
          <div>
            <span
              style={{ backgroundColor: Colors.errorColor }}
              className={[classes.labelBox].join(" ")}
            />
            <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Income
            </span>
          </div>
          <div className={[classes.ml48].join(" ")}>
            <span
              style={{ backgroundColor: Colors.mainBlue }}
              className={[classes.labelBox].join(" ")}
            />
            <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Hours
            </span>
          </div>
        </div>
        <div>
          <ButtonGroup
            btnIcon1={graphView === "bar" ? CalendarIconBlue : CalendarIconGray}
            btnIcon2={graphView === "line" ? ListIconBlue : ListIconGray}
            onClick1={() => setGraphView("bar")}
            onClick2={() => setGraphView("line")}
            customStyle={{ backgroundColor: Colors.white }}
          />
        </div>
      </div>

      {graphView === "bar" && (
        <div
          className={[classes.pb32].join(" ")}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        >
          <Bar options={options} data={data} />
        </div>
      )}

      {graphView === "line" && (
        <div
          className={[classes.pb32].join(" ")}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        >
          <Line options={options} data={data} />
        </div>
      )}

      <div className={[classes.lastDiv].join(" ")}>
        <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
          Want to learn more about how other sports work on Lytesnap?
        </p>
        <LinkButtonWithIcon
          text={"Check out seasons statistic"}
          customStyle={{
            ...Fonts.b2,
            fontSize: "16px",
            lineHeight: "16px",
            marginLeft: "10px",
          }}
          rightIcon={ArrowUpRightBlue}
          primary={true}
          onClick={() => setStatsModal(true)}
        />
      </div>

      <StatisticModal show={statsModal} setShow={setStatsModal} />
    </div>
  );
};
export default Analytics;
